module.exports = __webpack_public_path__ + "img/IMG-purchaser-bg2.262489c0.png";